import http from './http';

export default {
  get(id) {
    return http().get(`/v1/activities/${id}`);
  },
}
